import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Actions\Admin\GetTopicCreate::__invoke
* @see app/Actions/Admin/GetTopicCreate.php:17
* @route '/admin/topics/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/topics/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetTopicCreate::__invoke
* @see app/Actions/Admin/GetTopicCreate.php:17
* @route '/admin/topics/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetTopicCreate::__invoke
* @see app/Actions/Admin/GetTopicCreate.php:17
* @route '/admin/topics/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetTopicCreate::__invoke
* @see app/Actions/Admin/GetTopicCreate.php:17
* @route '/admin/topics/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\CreateTopic::__invoke
* @see app/Actions/Admin/CreateTopic.php:17
* @route '/admin/topics'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/topics',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Admin\CreateTopic::__invoke
* @see app/Actions/Admin/CreateTopic.php:17
* @route '/admin/topics'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\CreateTopic::__invoke
* @see app/Actions/Admin/CreateTopic.php:17
* @route '/admin/topics'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Actions\Admin\GetTopicEdit::__invoke
* @see app/Actions/Admin/GetTopicEdit.php:17
* @route '/admin/topics/{topic}/edit'
*/
export const edit = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/topics/{topic}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetTopicEdit::__invoke
* @see app/Actions/Admin/GetTopicEdit.php:17
* @route '/admin/topics/{topic}/edit'
*/
edit.url = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { topic: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { topic: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            topic: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        topic: typeof args.topic === 'object'
        ? args.topic.slug
        : args.topic,
    }

    return edit.definition.url
            .replace('{topic}', parsedArgs.topic.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetTopicEdit::__invoke
* @see app/Actions/Admin/GetTopicEdit.php:17
* @route '/admin/topics/{topic}/edit'
*/
edit.get = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetTopicEdit::__invoke
* @see app/Actions/Admin/GetTopicEdit.php:17
* @route '/admin/topics/{topic}/edit'
*/
edit.head = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\UpdateTopic::__invoke
* @see app/Actions/Admin/UpdateTopic.php:17
* @route '/admin/topics/{topic}'
*/
export const update = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/admin/topics/{topic}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Admin\UpdateTopic::__invoke
* @see app/Actions/Admin/UpdateTopic.php:17
* @route '/admin/topics/{topic}'
*/
update.url = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { topic: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { topic: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            topic: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        topic: typeof args.topic === 'object'
        ? args.topic.slug
        : args.topic,
    }

    return update.definition.url
            .replace('{topic}', parsedArgs.topic.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\UpdateTopic::__invoke
* @see app/Actions/Admin/UpdateTopic.php:17
* @route '/admin/topics/{topic}'
*/
update.patch = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Actions\Admin\DeleteTopic::__invoke
* @see app/Actions/Admin/DeleteTopic.php:17
* @route '/admin/topics/{topic}'
*/
export const deleteMethod = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/admin/topics/{topic}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Actions\Admin\DeleteTopic::__invoke
* @see app/Actions/Admin/DeleteTopic.php:17
* @route '/admin/topics/{topic}'
*/
deleteMethod.url = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { topic: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { topic: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            topic: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        topic: typeof args.topic === 'object'
        ? args.topic.slug
        : args.topic,
    }

    return deleteMethod.definition.url
            .replace('{topic}', parsedArgs.topic.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\DeleteTopic::__invoke
* @see app/Actions/Admin/DeleteTopic.php:17
* @route '/admin/topics/{topic}'
*/
deleteMethod.delete = (args: { topic: string | { slug: string } } | [topic: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

const topics = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default topics